// extracted by mini-css-extract-plugin
export default {"container":"Details_container__xApQi","copyUssd":"Details_copyUssd__HVZ87","code":"Details_code__yqnJl","inputNote":"Details_inputNote__eRbM9","btns":"Details_btns__tnrOR"};